import client from '@/api/client';
import urls from '@/api/urls';

// 通过任意层级菜单ID获取经过该ID的所有默认（首个）菜单
const getDefaultMenu = (replacement) => {
  return client.get(urls.GET_DEFAULT_MENU.format(replacement));
};

// 获取当前ID下的下级菜单
const getNextMenu = (replacement) => {
  return client.get(urls.GET_NEXT_MENU.format(replacement));
};

// 通过菜单ID获取文章
const getArticle = (replacement, params) => {
  return client.get(urls.GET_ARTICLE.format(replacement), { params });
};

// 通过菜单ID获取文章
const getArticleDetail = (replacement, params) => {
  return client.get(urls.GET_ARTICLE_DETIAL.format(replacement), { params });
};

/**
 * 获取指定位置的轮播
 * @param replacement {subjectId: 1}
 * @params data {location: 轮播位置Number}
 */
const getCarouselData = (replacement, data) => {
  return client.get(urls.GET_CAROUSEL_DATA.format(replacement), { params: data });
};

/**
 * 获取一级栏目
 * @param replacement: {subjectId: 1}
 */
const getFirstLevelMenu = (replacement) => {
  return client.get(urls.GET_FIRSR_LEVEL_MENU.format(replacement));
};

/**
 * 获取指定栏目下的文章列表
 * @param replacement {subjectId: 1}
 * @param data [1,2]
 * ?pageId=&pageSize=
 */
const postMenuArticle = (replacement, data, pageId, pageSize) => {
  return client.post(
    urls.POST_MENU_ARTICLE.format(replacement) + '?pageId=' + pageId + '&pageSize=' + pageSize,
    data
  );
};

/**
 * 获取栏目下的文章列表
 * @param replacement {subjectId: 1, menuId: 栏目id}
 */
const getMenuArticle = (replacement) => {
  return client.get(urls.GET_MENU_ARTICLE.format(replacement));
};

/**
 * 获取本栏目信息
 * @param replacement {subjectId: 1, menuId: 栏目id}
 */
const getMenuSelfInfo = (replacement) => {
  return client.get(urls.GET_MENU_SELF_INFO.format(replacement));
};

/**
 * 获取下一层栏目信息
 * @param replacement: {subjectId: 1, menuId: 栏目id}
 */
const getNextLevelMenuInfo = (replacement) => {
  return client.get(urls.GET_NEXT_LEVEL_MENU.format(replacement));
};

/**
 * 获取所有的外链信息
 * @param replacement：{subjectId: 1}
 */
const getLinksInfo = (replacement) => {
  return client.get(urls.GET_LINKS_INFO.format(replacement));
};

/**
 * 增加文章点击量
 * @param replacement {subjectId: 1, articleID: 文章id}
 * @returns {*}
 */
const getArticleClick = (replacement) => {
  return client.get(urls.GET_ARTICLE_CLICK.format(replacement));
};

/**
 * 获取栏目的上级菜单(每层菜单中的第一个)
 * @param replacement{subjectId: 1, menuId: 栏目id}
 * @returns {*}
 */
const getMenuLevels = (replacement) => {
  return client.get(urls.GET_MENU_LEVELS.format(replacement));
};

/**
 * 获取文章的上级菜单结构
 * @param replacement {subjectId: 1, articleId: 文章id}
 * @returns {*}
 */
const getArticleUpMenus = (replacement) => {
  return client.get(urls.GET_ARTICLE_UP_MENUS.format(replacement));
};

const countClick = (replacement) => {
  return client.get(urls.COUNT_CLICK.format(replacement));
};

/**
 * 搜索文章
 * @param replacement {subjectId： 1}
 * @param data {key, pageId, pageSize}
 */
const postSearchArticle = (replacement, key, pageId, pageSize) => {
  return client.post(
    urls.SEARCH_ARTICLE.format(replacement) +
      '?key=' +
      key +
      '&pageId=' +
      pageId +
      '&pageSize=' +
      pageSize
  );
};

export default {
  getDefaultMenu,
  getNextMenu,
  getArticle,
  getArticleDetail,
  getCarouselData,
  getFirstLevelMenu,
  postMenuArticle,
  getMenuSelfInfo,
  getMenuArticle,
  getNextLevelMenuInfo,
  getLinksInfo,
  getArticleClick,
  getMenuLevels,
  getArticleUpMenus,
  countClick,
  postSearchArticle,
};



// WEBPACK FOOTER //
// ./src/api/base.js